import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { usePetitionDetailsPageData } from 'src/app/pages/petitionDetails/pageContext';

import { useShareHeadline } from '../../../../hooks/shareHeadline';

export const DEFAULT_PHOTO = { url: 'https://static.change.org/images/default-petition.gif', width: 1120, height: 630 };

type UseMetaImageTags = ModelHookResult<{
	ogImage: string;
	ogImageWidth: string;
	ogImageHeight: string;
	ogTwitterImage: string;
}>;

export function useMetaImageOgTags(): UseMetaImageTags {
	const {
		data: {
			petition: { photo },
		},
	} = usePetitionDetailsPageData();
	const { resolveUrl } = useUtilityContext();
	const shareHeadline = useShareHeadline();

	let previewLinkImage;
	if (shareHeadline?.imageUrl) {
		previewLinkImage = {
			...DEFAULT_PHOTO,
			url: shareHeadline.imageUrl,
		};
	}
	const metaPhoto = previewLinkImage || photo?.petitionLarge || DEFAULT_PHOTO;
	const imageUrl = resolveUrl(metaPhoto.url);

	return {
		data: {
			ogImage: imageUrl,
			ogImageWidth: `${metaPhoto.width}`,
			ogImageHeight: `${metaPhoto.height}`,
			ogTwitterImage: imageUrl,
		},
	};
}
